(() => {
  if (customElements.get('mc-product-purchase')) return;
  customElements.define('mc-product-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.root) return;
      this.button = this.querySelector('[data-purchase-submit]');
      this.label = this.querySelector('[data-purchase-label]');
      this.price = this.querySelector('[data-purchase-price]');
      this.button.addEventListener('click', () => {
        const submit = this.root.querySelector('product-form .product-form__submit');
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        submit.click();
      });
      this.sync = () => {
        const submit = this.root.querySelector('product-form .product-form__submit');
        if (!submit) { this.hidden = true; return; }
        const pending = submit.getAttribute('aria-disabled') === 'true';
        this.button.disabled = submit.disabled || pending;
        this.label.textContent = pending ? 'Adding...' : submit.querySelector('span')?.textContent.trim() || 'Add to cart';
        const priceBox = this.root.querySelector(`#price-${this.dataset.section} .price`);
        const source = priceBox?.querySelector(priceBox.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        this.price.textContent = source?.textContent.trim() || '';
        if (this.observedSubmit !== submit) {
          this.intersection?.disconnect();
          this.observedSubmit = submit;
          this.intersection = new IntersectionObserver(([entry]) => { this.hidden = entry.isIntersecting; }, { threshold: 0 });
          this.intersection.observe(submit);
        }
        const error = this.root.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (error) error.scrollIntoView({ block: 'center', behavior: 'auto' });
      };
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.sync);
      });
      this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled','aria-disabled','hidden'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      try {
        const response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        const badge = document.getElementById('bagCount');
        if (badge) badge.textContent = cart.item_count;
      } catch (_) { /* The cart remains accessible from the header. */ }
    });
  }
})();
